<template>
  <b-button
    type="is-primary"
    outlined
    :size="size"
    icon-left="plus"
    :loading="loading"
    @click="$emit('click', $event)"
  >
    <slot></slot>
  </b-button>
</template>

<script>
export default {
  name: "FilterButtonAdd",
  props: {
    size: {
      type: String,
      default: 'is-small'
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>
